import { Button, Form, Input } from "antd";
import useAjax from "helpers/ajax";
import { showError, showMessage } from "helpers/utility";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding-top: 159px;
`;

const Card = styled.div`
  margin-bottom: 0;
  padding: 8px;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0px solid rgba(0, 0, 0, 0.125);
  width: 400px;
`;

const CardBody = styled.div`
  flex: 1 1 auto;
  padding: 40px 35px;
  h4 {
    font-size: 24px;
    color: #37474f;
    font-weight: 400;
    margin-bottom: 1rem;
    text-align: center;
  }
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
`;

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { post } = useAjax();
  const [loading, setLoading] = useState(false);

  const onFormSubmit = (values) => {
    const { password, confirmPassword } = values;
    setLoading(true);
    post("api/v1/users/applypassword", {
      token: searchParams.get("enc"),
      password,
      confirmPassword,
    })
      .then((resp) => {
        showMessage(resp.success, resp.message);
      })
      .catch((err) => {
        showError(err);
      })
      .finally(() => setLoading(false));
  };
  return (
    <Wrapper>
      <Card>
        <CardBody>
          <h4>Reset password?</h4>
          <hr />
          <Form layout="vertical" form={form} onFinish={onFormSubmit}>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true }, { min: 5 }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="Confirm password"
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                { required: true },
                { min: 5 },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Password doesn't match."));
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  loading={loading}
                  disabled={loading}
                >
                  Reset password
                </Button>
                <Button
                  size="large"
                  onClick={() => {
                    navigate("/account/login");
                  }}
                >
                  Back to sign in
                </Button>
              </div>
            </Form.Item>
          </Form>
        </CardBody>
      </Card>
    </Wrapper>
  );
};
export default ResetPassword;
